export default __webpack_public_path__ + "static/media/Pandlite 1 Web.5bce313e.png";